import {Pipe, PipeTransform} from '@angular/core';
import {getResourcePreview} from "../common";
import {IAppSettingsWrap, IResource, IResourcePreview} from "../interfaces";

@Pipe({
    name: 'PipeResourceUrl', pure: true
})
export class PipeResourceUrl implements PipeTransform {
    transform(resource: IResource, ...args: any[]): IResourcePreview {
        const core: IAppSettingsWrap = args[1];
        return getResourcePreview(resource, core, false, -1, false);
    }
}
